import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	setCurrentDocumentTopics, removeDocumentTopic, searchFunction,
	setCategoryType, filterByCommittee, setDocumentType, setDocumentFilter
} from '../actions';
import '../global';

class DocumentTopics extends Component {

	constructor( props ) {
		super( props );
		this.state = { value: '' };
	}

	componentDidUpdate() {
		if ( typeof this.props.documentFilter.tags !== 'undefined' ) {
			if ( this.props.currentDocumentTopics !== this.props.documentFilter.tags ) {
				this.props.setDocumentFilter( 'tags', this.props.currentDocumentTopics );
			}
		} else if ( this.props.currentDocumentTopics.length === 0 && typeof this.props.documentFilter.tags === 'undefined' ) {
			this.props.setDocumentFilter( 'tags', this.props.currentDocumentTopics );
		}
	}

	getTagsList() {
		if ( this.props.documentTags ) {
			const tags = this.props.documentTags;
			const tagOptions = tags.map( tag => <option>{ tag.name }</option> );
			return tagOptions;
		} else {
			return [];
		}

	}

	handleTag( event ) {
		this.setState( { value: event.target.value } );
	}

	handleAddTopic() {
		if ( this.state.value === '' ) {
			return 0;
		} else {
			this.props.setCurrentDocumentTopics( this.state.value );
			this.setState( { value: '' } );
		}
	}

	getTopicsHTML() {
		const topics = this.props.currentDocumentTopics;
		return topics.map( topic => (
			<div onClick={ this.removeTopic.bind( this, topic ) } className={ 'document-topic-selected' }>{ topic }
				<i className={ 'fa-solid fa-xmark remove-topic-icon' } />
			</div>
		) );
	}

	removeTopic( topic ) {
		this.props.removeDocumentTopic( topic );
	}

	clearFilters( event ) {
		event.preventDefault();
		this.props.searchFunction( '' );
		this.props.setCategoryType( '' );
		this.props.filterByCommittee( '' );
		this.props.setDocumentType( '' );
		this.props.setCurrentDocumentTopics( false );

	}

	render() {
		//todo should make this dynamic at some point.
		let activeTopics = '';
		let topicsHTML = this.getTopicsHTML();
		if ( topicsHTML.length !== 0 ) {
			activeTopics = (
				<div className={ 'active-topics-filter-container' }>Topics: { topicsHTML }</div>
			);
		}
		return (
			<div className="topics-container">
				<div className={ 'topics-input-field' }>
					<div className="topics-list col-xs-12 col-sm-6">
						<input className="form-control" placeholder={ 'Find topics' } value={ this.state.value } list="tags" onChange={ this.handleTag.bind( this ) } />
						<datalist id={ 'tags' }>

							{ this.getTagsList() }
						</datalist>
					</div>
					<button className="add-topic" onClick={ this.handleAddTopic.bind( this ) } type="button"><i className="fa-solid fa-circle-plus"></i> Add Topic</button>
				</div>
				{ activeTopics }
			</div>
		);
	}
}

function mapStateToProps( { categoryFilterType, documentTags, currentDocumentTopics, documentFilter } ) {
	return {
		categoryFilterType,
		documentTags,
		currentDocumentTopics,
		documentFilter
	};
}

export default connect( mapStateToProps, {
	setCurrentDocumentTopics,
	removeDocumentTopic,
	searchFunction,
	setCategoryType,
	filterByCommittee,
	setDocumentType,
	setDocumentFilter
} )( DocumentTopics );

